import {
    THEME_COLOR,
    GRAY_SCALE,
    BORDER,
    BODY_BACKGROUND
} from 'constants/ThemeConstant';

export const baseTheme = {
    // borderRadius: 10,
    borderRadius: 22,
    colorPrimary: THEME_COLOR.BLUE,
    colorSuccess: THEME_COLOR.CYAN,
    colorWarning: THEME_COLOR.GOLD,
    colorError: THEME_COLOR.VOLCANO,

    colorInfo: THEME_COLOR.BLUE,

    colorText: GRAY_SCALE.GRAY,
    colorBorder: BORDER.BASE_COLOR,

    bodyBg: BODY_BACKGROUND,

    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 36,

    fontFamily: `'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif`,

    fontSizeHeading2: 22,
    fontSizeHeading4: 17
};